import styled from 'styled-components';

/**
 * Who the composer writes to in a dispatcher thread: the customer, or a note.
 * Chips above the bar rather than a menu inside it: getting this wrong sends a
 * note to a customer, so the choice is on screen the whole time, in the colour
 * its bubble will wear.
 */

export const SwitchRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
`;

export const SwitchChip = styled.button<{
  $selected: boolean;
  $tone: 'everyone' | 'internal';
}>`
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.ease200ms};
  border: 1px solid
    ${({ theme, $tone }) =>
      $tone === 'internal' ? theme.chipYellow : theme.primary};
  background: ${({ theme, $tone, $selected }) =>
    !$selected
      ? theme.white
      : $tone === 'internal'
      ? theme.chipYellow
      : theme.primary};
  color: ${({ theme, $tone, $selected }) =>
    $selected
      ? theme.white
      : $tone === 'internal'
      ? theme.chipYellow
      : theme.primary};
`;
